<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card title="Perbandingan Rencana & Realisasi Tahun 2023" no-footer>
                    <div id="line-chart" style="min-height: 50vh;"></div>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="mt-4">
            <b-col cols="12">
                <b-card title="Realisasi Bedasarkan Sumber Dana Tahun 2023" no-footer>
                    <div id="bar-chart" style="min-height: 50vh;"></div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as echarts from 'echarts';

export default {
    data() {
      return {
        lineChartOptions: {
            color: [
                '#26519D',
                '#1fa504',
            ],
            title: {
                // text: 'Stacked Line'
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
            toolbox: {
                feature: {
                    //saveAsImage: {}
                }
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                axisPointer: {
                    type: 'shadow'
                },
                data: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Ags', 'Sep', 'Okt', 'Nov', 'Des']
            },
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: val => `Rp${this.$formatPrice(val)}`
                }

            },
            series: [
                {
                    name: 'Rencana',
                    type: 'line',
                    smooth: true,
                    // lineStyle: {
                    //     width: 3,
                    // },
                    tooltip: {
                        valueFormatter: val => `Rp${this.$formatPrice(val)}`
                    },
                    // stack: 'Total',
                    data: [12000000, 13200000, 10100000, 13400000, 9000000, 23000000, 21000000, 12000000, 13200000, 10100000, 13400000, 10000000]
                },
                {
                    name: 'Realisasi',
                    type: 'line',
                    smooth: true,
                    // lineStyle: {
                    //     width: 3,
                    // },
                    tooltip: {
                        valueFormatter: val => `Rp${this.$formatPrice(val)}`
                    },
                    // stack: 'Total',
                    data: [12000000, 13100000, 9900000, 11400000, 9000000, 21000000, 18000000, 11000000, 13000000, 10000000, 13400000, 9000000]
                },
            ]
        },
        lineChart: null,
        barChartOptions: {
            legend: {},
            tooltip: {},
            dataset: {
                source: [
                    ['Sumber Dana', 'BOS Reguler', 'BOS Kinerja', 'BOP PAUD dan Kesetaraan', 'SILPA', 'BOS Daerah'],
                    ['Jan', 21000000, 18000000, 11000000, 13000000, 10000000],
                    ['Feb', 12000000, 13100000, 9900000, 11400000, 9000000],
                    ['Mar', 21000000, 18000000, 11000000, 13000000, 10000000],
                    ['Apr', 21000000, 18000000, 11000000, 13000000, 10000000],
                    ['Mei', 12000000, 13100000, 9900000, 11400000, 9000000],
                    ['Jun', 12000000, 13100000, 9900000, 11400000, 9000000],
                    ['Jul', 21000000, 18000000, 11000000, 13000000, 10000000],
                    ['Ags', 12000000, 13100000, 9900000, 11400000, 9000000],
                    ['Sep', 21000000, 18000000, 11000000, 13000000, 10000000],
                    ['Okt', 12000000, 13100000, 9900000, 11400000, 9000000],
                    ['Nov', 12000000, 13100000, 9900000, 11400000, 9000000],
                    ['Des', 21000000, 18000000, 11000000, 13000000, 10000000],
                ]
            },
            xAxis: {
                type: 'category',
            },
            yAxis: {
                axisLabel: {
                    formatter: val => `Rp${this.$formatPrice(val)}`
                },
            },
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series: [
                { type: 'bar', barGap: 0, tooltip: { valueFormatter: val => `Rp${this.$formatPrice(val)}` } },
                { type: 'bar', barGap: 0, tooltip: { valueFormatter: val => `Rp${this.$formatPrice(val)}` } },
                { type: 'bar', barGap: 0, tooltip: { valueFormatter: val => `Rp${this.$formatPrice(val)}` } },
                { type: 'bar', barGap: 0, tooltip: { valueFormatter: val => `Rp${this.$formatPrice(val)}` } },
                { type: 'bar', barGap: 0, tooltip: { valueFormatter: val => `Rp${this.$formatPrice(val)}` } },
            ]
        },
        barChart: null,
      }
    },
    methods: {
        initLineChart () {
            let lineChartDom = document.getElementById('line-chart');
            this.lineChart = echarts.init(lineChartDom);
            this.lineChart.setOption(this.lineChartOptions)
        },
        initBarChart () {
            let barChartDom = document.getElementById('bar-chart');
            this.barChart = echarts.init(barChartDom);
            this.barChart.setOption(this.barChartOptions)
        }
    },
    mounted () {
        setTimeout(() => {
            this.initLineChart()
            this.initBarChart()
            document.body.addEventListener("resize", () => {
                if (this.lineChart) {
                    this.lineChart.resize();
                }
                if (this.barChart) {
                    this.barChart.resize();
                }
            });
        }, 500);
    },
    watch: {
      'doneCount': function (newValue) {
        if (this.lineChart) {
            this.lineChart.resize();
        }
        if (this.barChart) {
            this.barChart.resize();
        }
      },
    },
    computed: {
        // mix the getters into computed with object spread operator
        ...mapGetters({
            doneCount: 'account/isMinimizeNav'
        })
    }

}
</script>